/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import Box, { BoxProps } from '../Box/Box';

const LayoutContent = <T extends keyof JSX.IntrinsicElements>({
  sx,
  as = 'div' as T,
  children,
  ...boxProps
}: BoxProps<T>): React.ReactElement => {
  const boxSx = useMemo(
    () => ({
      width: '100%',
      boxSizing: 'border-box',
      padding: '0 3',
      flexGrow: '1',
      /* Tablet styles */
      '@media screen and (min-width: 768px)': {
        // padding: '0 3',
      },
      /* Desktop styles */
      '@media screen and (min-width: 1024px)': {
        // padding: '0 4',
      },
      /*
       * & > *:not(:last-child) is the better selector but seems
       * like its not supported on IE11.
       */
      '& > *': {
        marginBottom: '3',
      },
      '& > *:last-child': {
        marginBottom: '0',
      },
      '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)':
        {
          width: '432px',
        },
      ...(sx as any),
    }),
    [sx]
  );

  return (
    <Box as={as} sx={boxSx} {...boxProps}>
      {children}
    </Box>
  );
};

export default LayoutContent;
